import PropTypes from "prop-types";
import { always, ifElse, is, prop } from "ramda";
import React from "react";
import styled from "styled-components/macro";

import { BASE_VERTICAL_PADDING_LARGE_IN_PX } from "constants/index";
import { messagePropType, useIntl } from "hooks/useIntl";

const DefaultLabel = styled.label`
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  text-transform: ${ifElse(
    prop("withBorder"),
    always("uppercase"),
    always("initial")
  )}px;
  line-height: 1.1;
`;

const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  min-height: 1.5rem; /* Matching root line-height */
  ${({ omitBottomMargin }) =>
    `margin-bottom: ${ifElse(
      prop("withBorder"),
      always(omitBottomMargin ? 0 : BASE_VERTICAL_PADDING_LARGE_IN_PX + 3),
      always(omitBottomMargin ? 0 : BASE_VERTICAL_PADDING_LARGE_IN_PX)
    )}px;`}
  border-bottom: ${({ theme, withBorder }) =>
    withBorder ? `2px solid ${theme.grayAccent}` : "none"};
`;

const Label = ({
  children,
  withBorder = false,
  omitBottomMargin = false,
  ...rest
}) => {
  const { formatMessage } = useIntl();

  return (
    <LabelContainer withBorder={withBorder} omitBottomMargin={omitBottomMargin}>
      <DefaultLabel withBorder={withBorder} {...rest}>
        {is(String, children) ? children : formatMessage(children)}
      </DefaultLabel>
    </LabelContainer>
  );
};

export default Label;

Label.propTypes = {
  withBorder: PropTypes.bool,
  children: PropTypes.oneOfType([messagePropType, PropTypes.string]).isRequired,
};
